import {
  ButtonGroup,
  GhostButton,
  Link,
  PrimaryButton,
  Space,
  Text,
} from "@certn/cascadia-react";
import { CascadiaJsonFormContext } from "@certn/forms";
import { RenderError } from "@certn/forms/src/components/helpers/RenderError";
import { BaseLayout } from "@certn/forms/src/layouts/BaseLayout";
import { BaseLayoutContent } from "@certn/forms/src/layouts/BaseLayoutContent";
import { hasLabel } from "@certn/forms/src/utils";
import {
  CascadiaLayoutProps,
  withCascadiaLayoutProps,
} from "@certn/forms/src/wrappers/withCascadiaLayoutProps";
import { css } from "@emotion/css";
import { useContext } from "react";
import { Trans } from "react-i18next";

import { useApplication } from "../ApplicationContext";
function UKLegalSexControl(props: CascadiaLayoutProps) {
  const { isSummary } = useContext(CascadiaJsonFormContext);
  const { navigateToSection, prevSection } = useApplication();
  const { uischema, data: { uk_legal_sex } = {} } = props;

  const isDS = uischema?.options?.uk_criminal_check_provider === "DS";

  if (isSummary) {
    return null;
  }

  if (!hasLabel(uischema)) {
    return <RenderError>Invalid Category</RenderError>;
  }

  return (
    <BaseLayout {...props} className={styles.layout}>
      <Text as="h1" style="form/page-title">
        <Trans>UK Legal Sex</Trans>
      </Text>
      <Text style="form/body-secondary" color="text-base">
        <Trans>
          The UK Government requires stricter criteria for options of Identity
          Documents.
        </Trans>
      </Text>
      <BaseLayout {...props} className={styles.layout}>
        <BaseLayoutContent />
      </BaseLayout>
      {uk_legal_sex === "N" && (
        <Link
          linkStyle="monochrome"
          textStyle="global/body-secondary"
          textColor="text-weak"
          aria-labelledby="clickwrap-contract-link"
          testID="clickwrap-contract-link"
          href={
            isDS
              ? "https://www.mygov.scot/transgender-disclosure-application"
              : "https://www.gov.uk/guidance/transgender-applications"
          }
          target="_blank"
        >
          {isDS ? (
            <Trans>
              Please go to this link. We are unable to complete a Disclosure
              Scotland check
            </Trans>
          ) : (
            <Trans>
              Please go to this link. We are unable to complete a DBS check
            </Trans>
          )}
        </Link>
      )}
      <div className={styles.actionBar}>
        <ButtonGroup>
          {prevSection && (
            <GhostButton
              testID="section-back-button"
              leftIcon="chevron_left"
              onPress={async () => navigateToSection(prevSection)}
            >
              <Trans>Back</Trans>
            </GhostButton>
          )}
          <Space />
          {props.data && (
            <PrimaryButton testID="section-next-step-button" type="submit">
              <Trans>Next step</Trans>
            </PrimaryButton>
          )}
        </ButtonGroup>
      </div>
    </BaseLayout>
  );
}

const styles = {
  layout: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-4)",
  }),
  actionBar: css({
    paddingTop: "calc(var(--space-4) - 1px)",
    paddingBottom: "var(--space-4)",
    marginTop: "var(--space-5)",
    borderTop: "1px solid var(--border-base)",
  }),
};

UKLegalSexControl.displayName = "DBSConsent";

export const UKLegalSexControlRenderer =
  withCascadiaLayoutProps(UKLegalSexControl);
